import MyPage from '../module/MyPage.js';
import Embed from '../module/Embed.js';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default class Page extends MyPage {

	constructor() {

		super();

	}

	/*
	** init
	*/

	init() {

		// super
		super.init();

		// embed
		this.embed = new Embed();
		this.embed.load();

		// swiper
		const el = document.querySelector('.myswiper');

		if (!el) return;

		this.swiper = new Swiper(el.querySelector('.swiper'),
		{
			modules: [Navigation],
			loop: true,
			speed: 600,
			navigation: {
				nextEl: el.querySelector('.myswiper__next'),
				prevEl: el.querySelector('.myswiper__prev'),
			},
			on: {
				init: () => el.classList.add('ready')
			}
		});
	}


	/*
	** unload
	*/

	unload() {

		// super
		super.unload();

		// embed
		if (this.embed)
		{
			this.embed.unload();
			this.embed = null;
		}

		// swiper
		if (this.swiper)
		{
			this.swiper.destroy(true, true);
			this.swiper = null;
		}

	}
}